import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { toCSSPixel } from '../../../../utils/styles'
import { getTableRowQaProps, useTableRowModClassName } from '../../../Table'

import {
  getIsIntegrationsRowActive,
  renderIntegrationsCell,
} from './RentalPortalIntegrationsRow.utils'

import * as styles from './RentalPortalIntegrationsRow.module.css'

function RentalPortalIntegrationsRow({
  activeItem,
  columns,
  emptyColumnSize,
  focusedRow,
  getArrowNavigationItemProps,
  index,
  isResizing,
  item,
  resizingColumn,
  showCellBorder,
  onClick,
}) {
  const { t } = useTranslation()

  const className = useTableRowModClassName({
    className: styles.RentalPortalIntegrationsRow,
    isActive: getIsIntegrationsRowActive({ activeItem, focusedRow, item }),
  })

  function handleClick() {
    onClick(item)
  }

  return (
    <div
      {...getTableRowQaProps(item.portal)}
      {...getArrowNavigationItemProps?.(index)}
      className={className}
      onClick={handleClick}
    >
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderIntegrationsCell({
            isActive: column.name === resizingColumn,
            isResizing,
            item,
            name: column.name,
            showCellBorder,
            t,
            width: column.width,
          })}
        </Fragment>
      ))}
      {emptyColumnSize ? (
        <div style={{ width: toCSSPixel(emptyColumnSize) }} />
      ) : null}
    </div>
  )
}

export default RentalPortalIntegrationsRow
